import { Button, Chip } from '@mui/material';
import { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Header from './Header';
import Footer from './Footer';
import SchemaInput from './SchemaInput';
import IncompatibilityList from './IncompatibilityList';
import CompatibilityViolation from '../types/CompatibilityViolation';
import CompatibilityChip from './CompatibilityChip';
import useCompatibilityApi from '../hooks/useCompatibilityApi';

const AvroCompatibilityChecker = () => {
const [compatibilityViolation, setCompatibilityViolation] = useState(
    null as null | CompatibilityViolation,
  );

  const { result, error, loading, getCompatibility } = useCompatibilityApi({
    setCompatibilityViolation,
  });
  const [leftText, setLeftText] = useState(`{
  "namespace": "example.avro",
  "type": "record",
  "name": "user",
  "fields": [
      {"name": "name", "type": "string"},
      {"name": "favorite_number",  "type": "int"}
  ]
}`);
  const [rightText, setRightText] = useState(`{
  "namespace": "example.avro",
  "type": "record",
  "name": "user",
  "fields": [
      {"name": "favorite_number",  "type": "int"},
      {"name": "favorite_color", "type": "string", "default": "green"}
  ]
}`);

  function explainIncompatibilities(cv: CompatibilityViolation) {
    setCompatibilityViolation(compatibilityViolation === cv ? null : cv);
  }

  return (
    <div className="flex flex-col h-screen w-screen">
      <div className="flex flex-col items-center">
        <Header />
        <Button
          className="btn btn-blue w-1/4 m-1"
          variant="contained"
          onClick={() => getCompatibility(leftText, rightText)}
          disabled={loading}
          loading={loading}
          loadingIndicator={<CircularProgress size="20px" />}
        >
          Compare schemas
        </Button>
      </div>
      {(result != null || error !== '') && (
        <div className="flex flex-col items-center">
          <div className="text-center pt-4 text-base font-semibold">
            Comparison result:
          </div>
          {error ? (
            <div className="text-center p-4 text-lg font-semibold">{error}</div>
          ) : (
            <div className="flex flex-row">
              {result ? (
                <div>
                  {result.map((cv) => (
                    <CompatibilityChip
                      key={cv.type}
                      violation={cv}
                      onClick={explainIncompatibilities}
                    />
                  ))}
                </div>
              ) : (
                <Chip label="Incompatible" color="error" variant="outlined" />
              )}
            </div>
          )}
        </div>
      )}

      {compatibilityViolation?.incompatibilities?.length && (
        <IncompatibilityList violation={compatibilityViolation} />
      )}

      <div className="flex flex-grow">
        <SchemaInput
          placeholder="Enter previous schema definition here..."
          value={leftText}
          onChange={setLeftText}
        />
        <SchemaInput
          placeholder="Enter new schema definition here..."
          value={rightText}
          onChange={setRightText}
        />
      </div>
      <Footer />
    </div>
  );
}

export default AvroCompatibilityChecker;